import { writeData, deleteItemFromData, readAllData } from "utility"

const FK_FIELDS = [
  "patientId",
  "consultationId",
  "medicineId",
  "prescriptionId",
  "bilanId",
  "doctorOfficeId",
  "createdById",
  "editedById",
]

function normalizeIds(data) {
  const out = { ...data, id: String(data.id) }
  for (const fk of FK_FIELDS) {
    if (out[fk] != null) {
      out[fk] = String(out[fk])
    }
  }
  return out
}

export async function upsertOffline(store, data) {
  if (!data) return null
  const normalized = normalizeIds(data)
  delete normalized.__offline
  await writeData(store, normalized)
  return normalized
}

export async function mergeUpsertOffline(store, data, options = {}) {
  if (!data) return null
  const { markOffline } = options

  const all = await readAllData(store)
  const existing = all.find(
    (item) => String(item.id || item._id) === String(data.id),
  )

  const newData = {
    ...normalizeIds(data), // ← normalise les FK ici aussi
    ...(data.startDate && {
      startDate: new Date(data.startDate).toISOString(),
    }),
    ...(data.endDate && {
      endDate: new Date(data.endDate).toISOString(),
    }),
  }

  const merged = existing ? { ...existing, ...newData } : newData

  if (markOffline === true) {
    merged.__offline = true
    const now = new Date().toISOString()
    if (!existing) {
      if (!merged.creationDate) merged.creationDate = now
    } else {
      if (!data.modificationDate) merged.modificationDate = now
    }
  } else if (markOffline === false) {
    delete merged.__offline
  }

  await writeData(store, merged)
  return merged
}

export async function deleteOffline(store, id) {
  await deleteItemFromData(store, id)
  return { id }
}

export async function getByIdOffline(store, id) {
  const all = await readAllData(store)
  return all.find((item) => String(item.id || item._id) === String(id)) || null
}

export function normalizeEntity(entity) {
  return {
    ...entity,
    id: entity.id != null ? String(entity.id) : entity.id,
  }
}
